import { helpers } from 'react-wot-bootstrap'

import {
  getErrorMessage,
  getErrorHeader,
  getErrorReason,
  getMemberName,
  formatPlayer,
  BASE_ERRORS,
  BASE_ERROR_HEADERS,
} from './base'
import { getLocalizedName } from 'utils/clan_management/roles'
import { formatMessage } from 'locale'
import messages from './translations'

export const CHANGE_COMMANDER_SUCCESS = 'NOTIFICATIONS_CHANGE_COMMANDER_SUCCESS'
export const CHANGE_COMMANDER_ERROR = 'NOTIFICATIONS_CHANGE_COMMANDER_ERROR'


const getMessageChangeCommanderCooldown = (info) => {
    const translations = {
        today: formatMessage(messages.change_commander_today),
        tomorrow: formatMessage(messages.change_commander_tomorrow),
    }
    return formatMessage(messages.change_commander_cooldown, {
        date: helpers.formatDateAgoWith(info.change_leadership_cooldown, translations),
        time: helpers.isoToFormattedLocalTime(info.change_leadership_cooldown),
    })
}

const getMessageCannotChangeCommander = (info) => {
    const name = getMemberName(info.reason_not_in_clan_ids[0], info.members)
    return formatMessage(messages.change_commander_account_not_in_clan, { name: formatPlayer(name) })
}


export const changeCommanderSuccessNotification = (newCommander, ownRoleName) => ({
    type: CHANGE_COMMANDER_SUCCESS,
    payload: {},
    meta: {
        webToClient: {
            handler: 'sendNotification',
            params: {
                type: 'Warning',
                header: formatMessage(messages.change_commander_success_header),
                message: formatMessage(messages.change_commander_success_text, {
                    name: formatPlayer(newCommander),
                    role: getLocalizedName(ownRoleName),
                }),
            },
        },
    },
})

const CHANGE_COMMANDER_ERRORS = {
    ...BASE_ERRORS,
    cannot_change_role: getMessageCannotChangeCommander,
    change_commander_cooldown: getMessageChangeCommanderCooldown,
    'default': () => formatMessage(messages.change_commander_server_error),
}

export const changeCommanderErrorNotification = (error = {}, accountId, members) => {
    const reason = getErrorReason(error)
    const extra = {
        ...error.additional_data,
        accountId,
        members,
        messages: {
            banned: messages.change_commander_account_banned,
        },
    }
    return {
        type: CHANGE_COMMANDER_ERROR,
        payload: {},
        meta: {
            webToClient: {
                handler: 'sendNotification',
                params: {
                    type: 'ErrorSimple',
                    header: getErrorHeader(BASE_ERROR_HEADERS, reason),
                    message: getErrorMessage(CHANGE_COMMANDER_ERRORS, reason, extra),
                },
            },
        },
    }
}



// WEBPACK FOOTER //
// ./state/actions/CMT/Notifications/ChangeCommander.js